import { mergeWith, isArray } from 'lodash'

export default {
  RECEIVE_INIT_STATE (state, newstate) {
    mergeWith(state, newstate, (objValue, srcValue) => {
      if (isArray(objValue)) {
        return srcValue
      }
    })
  }
}



/** WEBPACK FOOTER **
 ** ./src/vuex/mutations.js
 **/